import type { KestrelStores } from "@kestrel/stores";
import { clientContext } from "../stores/index-universal";
import type { Context } from "./context.types";

export const serverContext = "__kestrel_ssr__" as const;

/**
 *
 *
 *
 *
 *
 *
 */
export const createRootContext = (stores: KestrelStores, c?: Context): Map<unknown, unknown> => {
  const context = new Map<unknown, unknown>([[clientContext, stores]]);
  if (import.meta.env.SSR && c) context.set(serverContext, c);
  return context;
};
